import React from 'react'
import { useContext } from 'react'
import { Auth0Context } from '../../Auth0'
import { useEffect } from 'react'
import { tokenSilentlyOption } from '../../../lib/Auth0'
import { getRootURL } from '../../../lib'
import { useState } from 'react'
import { useRouteMatch } from 'react-router-dom'
import { LANGUAGE_SHORT_CODE } from '../../../constants'

export const SettingsContext = React.createContext()

export function SettingsProvider(props) {
  const { children } = props

  const auth0Context = useContext(Auth0Context)

  const [isInitialized, setIsInitialized] = useState(false)
  const [userSettings, setUserSettings] = useState()
  const [version, setVersion] = useState()
  const [language, _setLanguage] = useState(undefined)

  var regstr = Object.keys(LANGUAGE_SHORT_CODE).map(key => LANGUAGE_SHORT_CODE[key]).join('|')
  const match = useRouteMatch(`/:language(${regstr})*`)

  useEffect(() => {
    if (!language) {
      setLanguage(match.params.language)
    }
  }, [match])

  useEffect(() => {
    if (isInitialized === false && auth0Context.isInitialized) {
      if (auth0Context.user) {
        auth0Context.auth0.getTokenSilently(tokenSilentlyOption)
        .then(accessToken => {
          return fetch(getRootURL() + '/user/settings', {
            method: 'POST',
            headers: {
              "Content-Type": "application/json",
              Authorization: 'Bearer ' + accessToken
            }
          })
        })
        .then(response => response.json())
        .then(json => {
          setUserSettings(json.settings)
          setIsInitialized(true)
        })
        .catch((error) => {
          console.dir(error)
        })
      }
      else {
        setUserSettings({})
        setIsInitialized(true)
      }
    }

    fetch(getRootURL() + '/version', {
      method: 'POST',
      headers: { "Content-Type": "application/json" }
    })
    .then(response => response.json())
    .then(json => {
      setVersion(json)
    })
  }, [auth0Context.isInitialized])

  const setLanguage = (language) => {
    _setLanguage(language ? language : LANGUAGE_SHORT_CODE.JA)
  }

  return (
    <SettingsContext.Provider
      value={{
        setLanguage,
        isInitialized,
        userSettings,
        version,
        language
      }}
    >
      {children}
    </SettingsContext.Provider>
  )
}


// WEBPACK FOOTER //
// ./src/Parts/Settings/components/SettingsProvider.js